import { WatermarkElementTypes, type IWatermarkSet } from '@/types/watermarks.types';
import { useEffect, useState } from 'react';

export const useWatermarkFonts = (watermark: IWatermarkSet) => {
  const [fontsLoaded, setFontsLoaded] = useState(false);

  useEffect(() => {
    setFontsLoaded(false);
    const textElements = watermark.elements.filter(
      (el) => el.type !== WatermarkElementTypes.image && el.settings.text?.font?.url
    );
    const fonts = Array.from(
      new Map(textElements.map((el) => [el.settings.text.font.url, el.settings.text.font])).values()
    );
    const fontFiles = [];
    for (const font of fonts) {
      fontFiles.push(new FontFace(font.name, `url(${font.url})`));
    }
    fontFiles.forEach((font) => {
      document.fonts.add(font);
    });

    const fontPromises = fontFiles.map((font) => font.load());

    Promise.all(fontPromises)
      .catch((e) => {
        console.error(`Error loading fonts: ${e}`);
      })
      .finally(() => {
        setFontsLoaded(true);
      });
  }, [watermark]);

  return fontsLoaded;
};
